import { createAction, props } from "@ngrx/store";
import { experienceData } from "../../interfaces/services-data";

export const __updateExperiences = createAction(
    '[Experiences] Update',
    props<experienceData>(),
)

export const __clearExperiences = createAction(
    '[Experiences] Clear'
)